import React from "react";
import { useSelector } from "react-redux";
import { selectCategories, selectCurrentModule, selectModules } from "../containers/App/selectors";
import { checkEmptyArray, checkEmptyObject } from "../services";
import { mapCategoryToHr, mapModuleToHr } from "../routes/LanguageMapper";

export default function useHrPageName(passedCategory: string, passedModule?: string): string | undefined {
   const categories = useSelector(selectCategories);
   const modules = useSelector(selectModules);
   const module = useSelector(selectCurrentModule);

   if (!passedCategory || !checkEmptyArray(categories) || !checkEmptyArray(modules)) {
      return;
   }

   const moduleObj = modules && modules.find(m => m.route == (mapModuleToHr(passedModule) || module));

   if (!checkEmptyObject(moduleObj)) {
      return;
   }

   const categoryObj = categories && categories.find(c => c.route == mapCategoryToHr(passedCategory, moduleObj.name) && c.moduleRoute == moduleObj.route);

   return categoryObj && categoryObj.displayName || moduleObj && moduleObj.displayName;
}


// WEBPACK FOOTER //
// ./src/utils/useHrPageName.tsx